const testNumber = () => {
  const number = (value: any): boolean => {
    return isNaN(value)
  }

  number.min = (value: any, lenght: number) => {
    if (value < lenght) return false
    return true
  }

  number.max = (
    value: any,
    lenght: number,
    message = `Deve ser no maximo ${lenght}`
  ) => {
    if (value <= lenght) return true
    return message
  }

  return number
}

const testString = () => {
  const string = (value: any): boolean => {
    if (typeof value !== 'string') return false
    return true
  }

  string.min = (value: any, lenght: number) => {
    if (value.length < lenght) return false
    return true
  }

  string.max = (value: any, lenght: number) => {
    if (value.length > lenght) return false
    return true
  }

  string.email = (
    email: string,
    message = `Informe um endereço de email valido`
  ) => {
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (regexEmail.test(email)) {
      return true
    } else {
      return message
    }
  }

  string.phoneNumber = (
    phoneNumber: string,
    message = `Informe um telefone valido`
  ) => {
    const regexPhoneNumber = /^(\(\d{2}\) \d{4}-\d{4}|\d{10})$/
    if (regexPhoneNumber.test(phoneNumber)) {
      return true
    } else {
      return message
    }
  }

  return string
}

const testPlugin = () => {
  const string = testString()
  const number = testNumber()
  const required = (value: any, message = 'Campo obrigatório') => {
    if (value === undefined || value === null) return message
    if (typeof value === 'string' && value.trim().length <= 0) return message
    return true
  }

  return {
    string,
    number,
    required,
  }
}

export default {
  install: (app: any) => {
    app.config.globalProperties.$test = testPlugin
  },
}

export type TestPlugin = typeof testPlugin
